module.exports = __webpack_public_path__ + "static/media/AbdulKhaliqDS.37ff638a.jpeg";